import Vue from 'vue';
import { prefixedField, indexedDB } from '@/_helpers';


const state = {
  client: null,
  consultType: null,
  models: {},
  showVetNotes: true,
  //currentIndex: 0,
};

const mutations = {
  toggleVetNotes(state)
  {
    state.showVetNotes = !state.showVetNotes
  },
  resetConsultSteps(state, originalSteps)
  {
    state.currentIndex = 0
    state.consultSteps = Object.assign({}, originalSteps)
  },
  setClient(state, client) { state.client = Number(client) },
  setConsultType: (state, consultType) => { state.consultType = consultType},
  setModels: (state, models) => { state.models = models},
  deleteField: (state, {stepName, fieldName}) => {
    Vue.delete(state.models[stepName], fieldName)
  },
  setFieldValue: (state, {stepName, fieldName, value}) => {
    Vue.set(state.models[stepName], fieldName, value)
  },
  setFieldComment: (state, {stepName, fieldName, value}) => {
    Vue.set(state.models[stepName].COMMENTS.current, fieldName, value)
  },
  setEmailNotification(state, {slug, value}) {
    let notifications = (state.models.EmailNotifications || {}).notifications || []

    let notification = notifications.find((item) => item.slug == slug)
    if (notification)
    {
      notification.marked = value
    }
  },
  deleteSchema(state) {
    state.status = {}
    state.currentIndex = 0
    state.client = null
    state.models = {}
    state.backendErrors = {}
  },

  //navigation
  setSection(state, index) {
    state.currentIndex = index
  },
  visitStep(state, stepSlug) {
    state.consultSteps[stepSlug].visited = true
  },
  completeStep(state, {stepSlug, isComplete}) {
    state.consultSteps[stepSlug].complete = isComplete
  },
  removeRequiredFields: (state, {stepName, value}) => {
    if (value) {
      let currentRequiredFields =  state.consultSteps[stepName].requiredFields || []
      state.consultSteps[stepName].requiredFields = currentRequiredFields.filter(field => !value.includes(field)) 
    } else {
      delete state.consultSteps[stepName].requiredFields
    }
  },
  addRequiredFields: (state, {stepName, value}) => {
    let newRequiredFields = new Set((state.consultSteps[stepName].requiredFields || []).concat(value))
    state.consultSteps[stepName].requiredFields = Array.from(newRequiredFields)
  },
  updateStateFromIDB(state, IDBState) {
    state.currentIndex = IDBState.currentIndex
    state.consultSteps = IDBState.consultSteps
    state.backendErrors = IDBState.backendErrors
  },
  addBackendErrors(state, errors) {
    state.backendErrors = errors
  },
}

const getters = {
  isGFC: (state) => { return state.dbName == 'general-farm-consult' } ,
	getProgram: (state) => (programSlug) => {
		return state.models.Programmes.programs.find((program) => program.slug == programSlug)
	},
  hasProgrammesComments: (state, getters) => {
    let commentNames = state.models.Programmes.programs
      .map(p => `${p.slug.replaceAll("-", "_")}_booking_notes`)
      .concat(["program_involvement_notes"]);
    return commentNames.some(
      cName => getters.getFieldComment(cName, "Programmes").current
    );
  },
  shouldSendMarkersNotification: (_, getters) => {
    return getters.hasModifiedProgrammes || getters.hasProgrammesComments
  },
  hasModifiedProgrammes: (state) => {
    return state.models.Programmes.programs.some(
      (program) => {
        return ((state.models.Programmes[
          prefixedField("active_before", program.id, "cm")
        ] || false) !=
          (state.models.Programmes[
            prefixedField("active_after", program.id, "cm")
          ] || false) ) || (
          (state.models.Programmes[
            prefixedField("option_before", program.id, "cm")
          ] || false) !=
            (state.models.Programmes[
              prefixedField("option_after", program.id, "cm")
            ] || false))
      }
    );
  },
	hasActiveProgrammes: (state) => {
		return state.models.Programmes.programs.some(
			(program) => state.models.Programmes[prefixedField('active_after', program.id, 'cm')]
		)
	},
  showVetNotes: (state) => { return state.showVetNotes },
  consultSteps: (state) => { return state.consultSteps },
  getStepName: (state) => (key) => {
    return state.consultSteps[key].title
  },
  currentStep: state => {
    return state.currentIndex + 1;
  },
  currentComponent: (state, getters) => {
    return Object.keys(getters.consultSteps)[state.currentIndex]
  },
  allBackendErrors: state => {
    return state.backendErrors
  },
  sectionBackendErrors: (state, getters) => {
    let key = Object.keys(getters.consultSteps)[state.currentIndex]
    return state.backendErrors[key] || {}
  },
  errorsFor: (state, getters) => (fieldName) => {
    return getters.sectionBackendErrors[fieldName]
  },
  hasErrors: (state, getters) => (fieldName) => {
    return Object.keys(getters.sectionBackendErrors).includes(fieldName)
  },
  isReadOnly: (state) => {
    return (state.models && state.models.Misc) ? state.models.Misc.read_only : true
  },
  getFieldValue: (state, getters) => (fieldName, modelName) => {
    let stepName = (modelName) ? modelName : getters.currentComponent
    return state.models[stepName][fieldName]
  },
  getFieldComment: (state, getters) => (fieldName, modelName) => {
    let stepName = (modelName) ? modelName : getters.currentComponent
    let comments = state.models[stepName]['COMMENTS']

    return {
      lastYear: comments['last_year'][fieldName],
      current: comments['current'][fieldName],
    }
  },
  seasonStartYear: (state) => {
    return state.models.Misc.season_start_year
  },
  consultOpenedDate: (state) => {
    return ((state.models || {}).Misc || {}).consult_opened_date || ''
  },

  // Navigation
  totalSteps: ( state, getters ) => {
    return Object.keys(getters.consultSteps).length
  },
  previousStepSlug: ( state, getters ) => {
    return Object.keys(getters.consultSteps)[state.currentIndex - 1] || ""
  },
  previousStep: ( state, getters ) => {
    return Object.assign(
      {slug: getters.previousStepSlug},
      getters.consultSteps[getters.previousStepSlug]
    )
  },
  nextStep: ( state , getters ) => {
    return Object.assign(
      {slug: getters.nextStepSlug},
      getters.consultSteps[getters.nextStepSlug]
    )
  },
  nextStepSlug: ( state , getters ) => {
    let currentIndex = state.currentIndex
    let stepNames = getters.consultSteps

    return Object.keys(stepNames)[currentIndex + 1] || ""
  },
  currentClientName: (state) => {
    return (state.models.Misc || {'consult_title': ''}).consult_title
  },
  getRequiredFields: (state) => (modelName) => {
    // TODO: try to move step validation into vuex so there's no need to add
    // extra complexity to each step when a new requiredField is added
    return (modelName ? [state.consultSteps[modelName]] : Object.values(state.consultSteps))
      .map((step) => step.requiredFields)
      .flat()
      .filter((field) => field)
  },
}

const actions = {
  addBackendErrors(context, {clientId, errors})
  {
    // updates bakcend errors on idb with data comming from
    // bad request. does not acccount for model in memory,
    // only idbdata
    context.commit('addBackendErrors', errors)
    return indexedDB.get(clientId, state.dbName).then(consult => {
      consult.backendErrors = errors
      return indexedDB.set(clientId, consult, context.state.dbName)
    })
  },
  setClient({ commit }, client) {
    commit('setClient', client)
  },
  deleteField({commit, getters}, {fieldName, modelName}) {
    let stepName = modelName || getters.currentComponent
    commit('deleteField', {fieldName, stepName})
  },
  setFieldValue({ commit, getters }, {fieldName, value, modelName}) {
    let stepName = modelName || getters.currentComponent

    commit('setFieldValue', {stepName, fieldName, value})
  },
  setFieldComment({ commit, getters }, {fieldName, value, modelName}) {
    let stepName = modelName || getters.currentComponent

    commit('setFieldComment', {stepName, fieldName, value})
  },
  updateCurrentModel: function({ dispatch }) {
    return dispatch('backupState',  state)
  },
  backupState({ state, getters }) {
    if (!getters.isReadOnly && typeof state.models == 'object' && Object.keys(state.models).length > 0) {
      let interimState = Object.assign({}, state)
      return indexedDB.set(state.client, interimState, state.dbName)
    }
  },
  removeRequiredFields({ commit, getters }, { modelName, value }) {
    let stepName = modelName || getters.currentComponent
    commit('removeRequiredFields', {stepName, value})
  },
  addRequiredFields({ commit, getters }, { modelName, value }) {
    let stepName = modelName || getters.currentComponent
    commit('addRequiredFields', {stepName, value})
  },
  // navigation
  setSection(context, step) {
    let index = Object.keys(context.getters.consultSteps).indexOf(step)
    context.commit('visitStep', step)
    if (!context.getters.isReadOnly)
    {
      // return context.dispatch('backupState').then(() => context.commit('setSection', index))
      context.commit('setSection', index)
    } else {
      context.commit('setSection', index)
    }
  },
  deleteSchema({ commit, state }) {
    commit('deleteSchema')
    return indexedDB.delete(state.client, state.dbName)
  },
}


export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
